import Vue from 'vue';
import Router from 'vue-router';

import createLeagueRoutes from '@/modules/create-league/router';
// import homepageRoutes from '@/modules/homepage/router';
import profileRoutes from '@/modules/profile/router';
import leaguesRoutes from '@/modules/leagues/router';
import contestsRoutes from '@/modules/contests/router';
import withdrawRoutes from '@/modules/withdraw/router';
import authRoutes from '@/modules/auth/router';
import lobbyRoutes from '@/modules/lobby/router';
import createRoutes from '@/modules/create/router';
import researchRoutes from '@/modules/research/router';
import helpRoutes from '@/modules/help/router';
import createTeamRoutes from '@/modules/create-team/router';
import store from '../store/store';
import { IS_LOGGED_IN } from '@/modules/auth/store/constants';

import Route from '../shared/models/Route';

const publicPages = ['/', '/register', '/login', '/confirm'];

Vue.use(Router);

const routes: Route[] = [
    ...createLeagueRoutes,
    ...profileRoutes,
    ...leaguesRoutes,
    ...contestsRoutes,
    ...withdrawRoutes,
    ...authRoutes,
    ...lobbyRoutes,
    ...createRoutes,
    ...researchRoutes,
    ...helpRoutes,
];

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

});

router.beforeEach((to, from, next) => {
    const authRequired = !publicPages.includes(to.path);
    const token = window.localStorage.getItem("token");
    if (authRequired) {
        if (store.getters[IS_LOGGED_IN] && token && token !== "undefined") {
            next();
            return;
        } else {
            next('/login');
        }
    } else {
        next();
    }
});

router.beforeEach((to, from, next) => {
    const authRequired = !publicPages.includes(to.path);
    const token = window.localStorage.getItem("token");
    const isLoggedIn = store.getters[IS_LOGGED_IN] && token && token !== "undefined";
    if (!authRequired && isLoggedIn) {
        next('/lobby');
    } else {
        next();
    }
});

export default router;

